export default "__VITE_ASSET__fa423584__"